import { Skeleton } from '@mui/material';

const NotificationSkeleton = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        width: '100%',
        backgroundColor: '#fff',
        padding: 10,
        borderRadius: 5,
      }}>
      <Skeleton variant="circular" width={40} height={40} style={{ marginTop: 5 }} />
      <div style={{ flex: 1 }}>
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width={100} />
      </div>
    </div>
  );
};

export default NotificationSkeleton;
